export const blockIconsActionHome = (
	<span className='material-symbols-outlined'>home</span>
);
